<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2413_8974)">
<circle cx="16" cy="16" r="16" fill="#FF7222"/>
<g clip-path="url(#clip1_2413_8974)">
<path d="M16 2.6665C8.63996 2.6665 2.66663 8.63984 2.66663 15.9998C2.66663 23.3598 8.63996 29.3332 16 29.3332C23.36 29.3332 29.3333 23.3598 29.3333 15.9998C29.3333 8.63984 23.36 2.6665 16 2.6665ZM16 6.6665C18.2133 6.6665 20 8.45317 20 10.6665C20 12.8798 18.2133 14.6665 16 14.6665C13.7866 14.6665 12 12.8798 12 10.6665C12 8.45317 13.7866 6.6665 16 6.6665ZM16 25.5998C12.6666 25.5998 9.71996 23.8932 7.99996 21.3065C8.03996 18.6532 13.3333 17.1998 16 17.1998C18.6533 17.1998 23.96 18.6532 24 21.3065C22.28 23.8932 19.3333 25.5998 16 25.5998Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_2413_8974">
<rect width="32" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_2413_8974">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
